import { useCallback } from "react"

const DOMAIN = "Customers"
const SUBDOMAIN = "SignUp"
const PAGE = "Web"

const PAYLOAD = { origin: "Web" }

export enum TrackingAction {
  ViewedIntro = "ViewedIntro",
  ViewedPrivacyPolicy = "ViewedPrivacyPolicy",
  EnteredInfo = "EnteredInfo",
  EditedInfo = "EditedInfo",
  ViewedConfirm = "ViewedConfirm",
  ClickedConfirm = "ClickedConfirm",
  ViewedSignUpComplete = "ViewedSignUpComplete",
  ClickedNoReceipt = "ClickedNoReceipt",
  ClickedSendReceipt = "ClickedSendReceipt",
  ViewedReceiptSent = "ViewedReceiptSent",
  ClickedResendReceipt = "ClickedResendReceipt",
  ClickedConfirmResendReceipt = "ClickedConfirmResendReceipt",
}

export enum PrivacyPolicyFrom {
  SignUpPage = "SignUpPage",
  OptOutPage = "OptOutPage",
  SellerPrivacyPage = "SellerPrivacyPage",
}

export const useSignUpTracking = (purchaseId?: string) => {
  const track = useCallback(
    (action: TrackingAction, morePayload: Record<string, any> = {}) => {
      const payload = {
        ...PAYLOAD,
        purchaseId,
        ...morePayload,
      }
      window.izPushEvent(DOMAIN, SUBDOMAIN, PAGE, action, payload)
    },
    [purchaseId],
  )

  return {
    track,
  }
}
